import Logo from './Logo';

export default Logo;



// WEBPACK FOOTER //
// ./src/assets/Logo/index.js